/*******************************************************************
* PAGE        : AppCommonConstants
* REMARKS     : Comman App Constants
* CREATED ON  : 13-11-2025
* AUTHOR      : Bamroliya.Paras
* MODIFY      : Bamroliya.Paras
* MODIFY ON   : 05-03-2026
********************************************************************/

import * as XLSX from 'xlsx';
import moment from "moment/moment";

const danger = { color: "#721c24", backgroundColor: "#f8d7da" };
const success = { color: "#3c763d", backgroundColor: "#dff0d8" };
const primary = { color: "#0a34b1b8", backgroundColor: "#CDCFFF" };
const reject = { color: "#a94442", backgroundColor: "#f2dede" };
const open = { color: "#20b756", backgroundColor: "#2EC4B6" };
const progress = { color: "#6D225C", backgroundColor: "#FFD4F6" };
const warning = { color: "#856404", backgroundColor: "#fff3cd" };
const orange = { color: "#bf762a", backgroundColor: "#FFEFCC" };
const pink = { color: "#d582a4", backgroundColor: "#df12ac4a" };

export const chipStyleColors = [
    { ...danger, value: "NO", name: "NO", width: "60px" },
    { ...danger, value: false, name: "NO", width: "60px" },
    { ...success, value: "YES", name: "YES", width: "60px" },
    { ...success, value: true, name: "YES", width: "60px" },

    { ...primary, value: "In Draft", name: "In Draft", width: "100px" },

    { ...reject, value: "No Select", name: "No Select", width: "100px" },
    { ...success, value: "Single Select", name: "Single Select", width: "100px" },
    { ...success, value: "Multi Select", name: "Multi Select", width: "100px" },

    { ...primary, value: "Pending", name: "Pending", width: "100px" },
    { ...success, value: "Approved", name: "Approved", width: "100px" },
    { ...success, value: "Accept", name: "Accept", width: "100px" },

    { ...reject, value: "Reject", name: "Reject", width: "100px" },
    { ...reject, value: "Rejected", name: "Rejected", width: "100px" },

    { color: "#1a1110c7", value: "WorkOrders", name: "WorkOrders", width: "60px" },

    { ...open, value: "Open", name: "Open", width: "100%" },

    { ...warning, value: "Assign", name: "Assign", width: "100%" },

    { ...open, value: "Registered", name: "Registered", width: "100%" },
    { ...open, value: "Created", name: "Created", width: "100%" },
    { ...open, value: "New", name: "New", width: "100%" },

    { ...reject, value: "Cancelled", name: "Cancelled", width: "100%" },

    { ...progress, value: "Started", name: "Started", width: "100%" },
    { ...progress, value: "InProcess", name: "In Process", width: "100%" },

    { ...primary, value: "Paused", name: "Paused", width: "100%" },

    { ...pink, value: "Acknowledged", name: "Acknowledged", width: "100%" },
    { ...pink, value: "Reopen", name: "Reopen", width: "100%" },

    { ...success, value: "Completed", name: "Completed", width: "100%" },
    { ...success, value: "Resolved", name: "Resolved", width: "100%" },

    { ...orange, value: "Close", name: "Close", width: "100%" },
    { ...orange, value: "Closed", name: "Closed", width: "100%" },

    { ...reject, value: "Critical", name: "Critical", width: "60px" },

    { ...progress, value: "High", name: "High", width: "100%" },
    { ...primary, value: "Medium", name: "Medium", width: "100%" },
    { ...orange, value: "Low", name: "Low", width: "100%" },

    { value: "Sender", name: "Sender", width: "80px" },
    { value: "Recipient", name: "Recipient", width: "80px" },

    { color: "black", backgroundColor: "#80808099", value: "" },

    { ...success, value: "Available", name: "Available", width: "100px" },
    { ...success, value: "ResolveAndClose", name: "Resolve And Close", width: "100px" },

    { ...progress, value: "On Call", name: "On Call", width: "100%" },
    { ...progress, value: "Receipt", name: "Receipt", width: "100%" },

    { ...primary, value: "On Break", name: "On Break", width: "100%" },

    { ...reject, value: "On Leave", name: "On Leave", width: "60px" },
];

export const handleExportToExcel = (filteredData, fileName, fileExtension) => {

    // ✅ Deep copy data
    const data = filteredData.map(item => {
        const { MaxRows, RowNumber, id, isactive, ...rest } = item;
        return rest;
    });

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    XLSX.writeFile(
        wb,
        fileName + moment(new Date()).format("DD_MM_YYYY") + fileExtension
    );
};

export const AppConstant = {
    // Pagination: [10, 25, 50, 100, 200, 500, 1000],
    Pagination: [10, 25, 50, 100, 200, 500, 1000, { label: "All", value: -1 }],
    Pagination2: [
        { value: 10, label: '10' },
        { value: 25, label: '25' },
        { value: 50, label: '50' },
        { value: 100, label: '100' },
        { value: 200, label: '200' },
        { value: 500, label: '500' },
        { value: 1000, label: '1000' },
        { value: -1, label: 'All' },

    ],
    DefaultSort: "DESC",
    SortDirection: "ASC",
    DefaultRecordsPerPage: 10,
};

export const getFileIcon = (file) => {
    const type = file.type || "";
    const name = file.name?.toLowerCase() || "";

    // Images
    if (type.startsWith("image/")) return "🖼️";

    // PDF
    if (type === "application/pdf" || name.endsWith(".pdf")) return "📄";

    // Word
    if (
        type.includes("word") ||
        name.endsWith(".doc") ||
        name.endsWith(".docx")
    ) return "📝";

    // Excel
    if (
        type.includes("sheet") ||
        name.endsWith(".xls") ||
        name.endsWith(".xlsx") ||
        name.endsWith(".csv")
    ) return "📊";

    // PowerPoint
    if (
        type.includes("presentation") ||
        name.endsWith(".ppt") ||
        name.endsWith(".pptx")
    ) return "📈";

    // ZIP / RAR / 7z
    if (
        type.includes("zip") ||
        type.includes("compressed") ||
        name.endsWith(".zip") ||
        name.endsWith(".rar") ||
        name.endsWith(".7z")
    ) return "🗜️";

    // Text files
    if (
        type.startsWith("text/") ||
        name.endsWith(".txt") ||
        name.endsWith(".log")
    ) return "📃";

    // Code files
    if (
        name.endsWith(".js") ||
        name.endsWith(".jsx") ||
        name.endsWith(".ts") ||
        name.endsWith(".tsx") ||
        name.endsWith(".html") ||
        name.endsWith(".css") ||
        name.endsWith(".json") ||
        name.endsWith(".xml")
    ) return "💻";

    // Audio
    if (type.startsWith("audio/")) return "🎵";

    // Video
    if (type.startsWith("video/")) return "🎬";

    // Default
    return "📁";
};


export const FormIDs = {
    ComplainInward: 356,
    ComplainManagement: 357,
    VisitReport: 362
};

export const IsEmpty = (value) => {
    if (value === "" || value === null || value === undefined) {
        return true;
    } else { return false; }
}

export const isValidPhoneNumber = (phone) => {
    if (!phone) return false;

    // Remove everything except digits
    const digits = phone.replace(/\D/g, "");

    // International numbers are typically 7–15 digits
    return digits.length >= 7 && digits.length <= 15;
};

const parseDate = (dateString) => {
    if (!dateString) return null;

    // Already ISO format
    if (dateString.includes("-")) {
        return new Date(dateString);
    }

    // DD/MM/YYYY
    if (dateString.includes("/")) {
        const [day, month, year] = dateString.split("/");
        return new Date(year, month - 1, day);
    }

    return new Date(dateString);
};

export const CommonFormatDate = (dateString, format = "DD-MM-YYYY") => {
    const date = parseDate(dateString);
    if (!date || isNaN(date)) return "";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    switch (format) {
        case "DD/MM/YYYY":
            return `${day}/${month}/${year}`;

        case "YYYY-MM-DD":
            return `${year}-${month}-${day}`;

        case "DD-MM-YYYY":
        default:
            return `${day}-${month}-${year}`;
    }
};

export const CommonFormatDateTime = (dateString, format = "DD-MM-YYYY hh:mm A") => {
    const date = parseDate(dateString);
    if (!date || isNaN(date)) return "";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");

    const ampm = hours >= 12 ? "PM" : "AM";
    hours = String(hours % 12 || 12).padStart(2, "0");

    switch (format) {
        case "DD/MM/YYYY hh:mm A":
            return `${day}/${month}/${year} ${hours}:${minutes} ${ampm}`;

        case "YYYY-MM-DD hh:mm A":
            return `${year}-${month}-${day} ${hours}:${minutes} ${ampm}`;

        case "DD-MM-YYYY hh:mm A":
        default:
            return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
    }
};

export const format18_3 = (value) => Number(value).toFixed(3);

export const calculateQuantitiesFormula = (quantity = 0, conversionFactor = 1, transactionMode = "U") => {
    const qty = Number(quantity) || 0;
    const factor = Number(conversionFactor) || 1;

    if (transactionMode === "U") {
        return {
            unitQuantity: format18_3(qty),
            alternateUnitQuantity: format18_3(qty * factor),
        };
    }

    if (transactionMode === "A") {
        return {
            unitQuantity: format18_3(qty / factor),
            alternateUnitQuantity: format18_3(qty),
        };
    }

    return {
        unitQuantity: format18_3(qty),
        alternateUnitQuantity: format18_3(qty),
    };
};
